export * from './Timer';

import Timer from './Timer';
export default Timer;
